import TileState from 'ol/TileState'

/**
 * loadEndCallback
 * Wire up a callback which will be called when the tileLoader finishes.
 */
let callback

/**
 * loadEndCallback
 * Wire up a callback to be called whenever a map loader decides a map has
 * loaded.
 */
export function loadEndCallback(cb) {
    callback = cb
}

// Counters to keep track of tiles loading and loaded.
let loading = 0, loaded = 0

/**
 * handleProgress
 * Private function to keep track of tile loading and call the supplied
 * callback when done. Used by the custom loaders exported from this module.
 */
function handleProgress() {
    window.setTimeout(() => {
        loaded++
        if (loaded/loading == 1) callback()
    }, 1000)
}

/**
 * tileLoader
 * A custom tile loader for an OL TileLayer, to convert the tiles to black
 * and white.
 */
export function tileBWLoader(tile, src) {
    let xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'

    xhr.addEventListener('loadstart', function() {
        loading++
    })

    xhr.addEventListener('loadend', function() {
        const data = this.response

        if (data !== undefined) {
            const canvas = document.createElement("canvas")
            canvas.width = 256
            canvas.height = 256
            let ctx = canvas.getContext("2d")
            ctx.filter ="grayscale(100%) brightness(120%) contrast(90%)"

            let img = new Image()
            img.onload = function() {
                ctx.drawImage(this, 0, 0)
                tile.getImage().src = canvas.toDataURL()
                handleProgress()
            }
            img.src = URL.createObjectURL(data)
        } else {
            tile.setState(TileState.ERROR)
            handleProgress()
        }
    })

    xhr.addEventListener('error', function() {
        tile.setState(TileState.ERROR)
        handleProgress()
    })

    xhr.open('GET', src)
    xhr.send()
}

/**
 * tileTracker
 */
export function makeTileTracker(source) {
    source.on('tileloadstart', () => {
        loading++
    })
    source.on('tileloadend', () => {
        handleProgress()
    })
    source.on('tileloaderror', () => {
        handleProgress()
    })
    return source
}
